import {
    calendarGamePath,
    timeFilterSlug,
} from '@app/router/constants/linkConstants';
import { RouteIdentity } from '@app/router/types';

export const LinkPt: RouteIdentity<string> = {
    App: {
        Home: `/${timeFilterSlug}?`,
        Info: '/info',
        Wiki: '/blog/:pageSlug',
        NotFound: '/404',
        NotAuthorized: '/401',
        TermsAndConditions: '/termos-e-condicoes',
        CatchAll: '*',
        IdCardVerificationCaptive: '/verificar-identidade',
        VerifyPhoneCaptive: '/verificar-telefone',
        BrMigrationComplete: '/migracao-concluida',
    },
    Account: {
        Container: '/perfil',
        Profile: '', // empty on purpose
        PaymentGatewayStatus: 'static/html/paymentGatewayStatus.html',
        Activate: '/activate-account',
        PasswordRecovery: '/recuperacao-de-senha',
        ForgotPassword: '/senha-esquecida',
        Recovery: '/recuperacao-de-conta',
        Register: '/registro',
        ResendActivationEmail: '/reenviarEmaildeAtivacao',
        ContinueRegistration: '/continuar-registro',
        Deposit: 'deposito',
        History: 'historico/:type?',
        Settings: 'configuracoes',
        Withdrawal: 'saque',
        DocumentUpload: 'envio-de-documento',
        IdentityVerification: 'verificacao-de-identidade',
        IdentityVerificationUploadAdditional: 'envio-de-documentos',
        ResponsibleGaming: 'jogo-responsavel',
        DepositLimit: 'jogo-responsavel/limite-de-deposito',
        BettingLimit: 'jogo-responsavel/limite-de-apostas',
        LossLimit: 'jogo-responsavel/limite-de-perdas',
        SessionLimit: 'jogo-responsavel/limite-de-sessao',
        SelfExclusion: 'jogo-responsavel/auto-exclusao',
        TimeOut: 'jogo-responsavel/pausa',
        RealityCheck: 'jogo-responsavel/verificacao-de-realidade',
        AccountClosure: 'jogo-responsavel/fechamento-de-conta',
        MyMessages: 'minhas-mensagens',
        ChangePhone: 'mudar-telefone',
        ReferAFriend: 'indicar-um-amigo',
        HelpAndSupport: 'ajuda-e-suporte',
        ChatPlaceholder: 'chat',
        MySocial: 'meu-social',
        EditMySocial: 'editar-perfil-social',
        BlockedUsers: 'usuarios-bloqueados',
        MyAccount: 'minha-conta',
        ChangePassword: 'atualizacao-de-senha',
        SettingsBetslip: 'bilhete-de-aposta',
        SwitchLanguage: 'mudar-idioma',
        SwitchTheme: 'mudar-tema',
        LicencePreferences: 'licenca-preferencias',
        LoginHistory: 'historico-de-login',
        AccountSecurity: 'not-used',
    },
    Sport: {
        OfferEvent: '/evento/:eventSlug/',
        PrematchOffer: '/apostas',
        BetSlip: '/bilhete-de-aposta',
        Filter: '/filtro',
        Search: '/busca',
        Favourites: '/favoritos',
        Category: '/apostas/:sportSlug?/:categorySlug?',
        CategoryPerTime: `/apostas/:sportSlug?/:categorySlug?/${timeFilterSlug}`,
        SportCompetitions: '/apostas/:sportSlug/competicoes',
        Competition: `/apostas/:sportSlug/:categorySlug/:tournamentSlug/${timeFilterSlug}?`,
        EventRedirect: '/event/:id(\\d+)',
        TournamentRedirect: '/torneio/:id([\\d,]+)',
        CategoryRedirect: '/categoria/:id(\\d+)',
        SuperAdvantage: '/super-placar/:sportSlug?',
        PriceBoost: '/odds-aumentadas/:sportSlug?',
        MultiEventBetBuilder: '/multi-criar-aposta/:sportSlug?',
        PopularBets: '/apostas-populares',
        TopWinners: '/maiores-vencedores',
        Social: '/apostas/:sportSlug/social',
    },
    Lottery: {
        Offer: `/lotto-bets/${timeFilterSlug}?`,
    },
    News: {
        Feed: '/noticias',
        Article: '/noticias/:articleSlug',
        Articles: '/artigos',
    },
    Free2Play: {
        BingoBash: '/bingobash',
        SuperSpin: '/superspin',
        FreeGamesInfo: '/jogos-gratis',
        SportCaller: '/superprono',
        SuperMillion: '/supermillion',
        CalendarGame: `/${calendarGamePath}`,
        SuperShot: '/supershot',
        TopManager: '/top-manager',
        FantasticDuels: '/fantasticDuels.path',
    },
    GrowthMarketing: {
        LandingIntro: '/intro',
        PromotionsInfo: '/promocoes',
        NewBettingSiteSerbia: '/nova-kladionica-u-srbiji',
    },
    Native: {
        AppsFooter: '/footerframe',
        Wiki: '/nativewiki/:pageSlug',
    },
    BonusAndComms: {
        LpBonus: '/primulbonus*',
        // Napoleon cannot use bonus wording
        PromotionHub: '/promocoes-e-bonus',
        Notifications: '/notificacoes',
        MarketingConsent: 'consentimento-de-marketing',
    },
    Loyalty: {
        Supercoins: '/supercoins',
    },
};
